export const PIN_CARD_PROPS = {
  cardText: 'Make logging in easy. Input a set of numbers that is unique but memorable to you.',
  cardTitle: 'Create a 6 digit pin number',
};

export const PIN_CONFIRMATION_CARD_PROPS = {
  cardText: 'Make logging in easy. Input a set of numbers that is unique but memorable to you.',
  cardTitle: 'Re-enter your 6 digit pin number',
};
